module.exports = __webpack_public_path__ + "static/media/Visualizing stories of sexual harassment in the academy_ Communit.8099bec2.pdf";